export default __webpack_public_path__ + "ec6cb41bd23f9db7159d3937fd0fe86c.svg";